export default "__VITE_ASSET__Cdp4pieP__"